import _get from 'lodash/get';

export default class ProductFilterService {
  /* @ngInject */
  constructor(HttpService, ProductFilterOptionModel, AuthService, ProductFilterSelectModel, GeographyService, PRODUCT_CONSTANT, RouterService) {
    this.httpService = HttpService;
    this.authService = AuthService;
    this.geographyService = GeographyService;
    this.ProductFilterOptionModel = ProductFilterOptionModel;
    this.ProductFilterSelectModel = ProductFilterSelectModel;
    this.PRODUCT_CONSTANT = PRODUCT_CONSTANT;
    this.routerService = RouterService;
    this.SERVICE = `${HttpService.BASE_PATH}/products/filters`;
    this.store = {};
    // this.store = {launchDatesFilters: this._createLaunchDateFilter()};
  }

  initFilters() {
    const {GENDER, CATEGORY, TYPE, PRODUCTLINE, SEASON, THEME, AVAILABILITY, STORE, MARKET, REGION, IN_STOCK, SIZE, COLLECTION} = this.PRODUCT_CONSTANT.FILTER;
    this.DEFAULT_OPTIONS = {
      [STORE]: new this.ProductFilterOptionModel(null, 'All Stores'),
      [MARKET]: new this.ProductFilterOptionModel(null, 'All Markets'),
      [REGION]: new this.ProductFilterOptionModel(null, 'All Regions'),
      [GENDER]: new this.ProductFilterOptionModel(null, 'All Genders'),
      [CATEGORY]: new this.ProductFilterOptionModel(null, 'All Categories'),
      [TYPE]: new this.ProductFilterOptionModel(null, 'All Types'),
      [PRODUCTLINE]: new this.ProductFilterOptionModel(null, 'All Product Line'),
      [SEASON]: new this.ProductFilterOptionModel(null, 'All Seasons'),
      [THEME]: new this.ProductFilterOptionModel(null, 'All Themes'),
      [COLLECTION]: new this.ProductFilterOptionModel(null, 'All collections'),
      [SIZE]: new this.ProductFilterOptionModel(null, 'All sizes'),
      [AVAILABILITY]: new this.ProductFilterOptionModel(IN_STOCK, 'In stock'),
    };
    this.SELECT = {
      [STORE]: this.createSelectFactory(STORE),
      [MARKET]: this.createSelectFactory(MARKET),
      [REGION]: this.createSelectFactory(REGION),
      [GENDER]: this.createSelectFactory(GENDER),
      [CATEGORY]: this.createSelectFactory(CATEGORY),
      [TYPE]: this.createSelectFactory(TYPE),
      [PRODUCTLINE]: this.createSelectFactory(PRODUCTLINE),
      [SEASON]: this.createSelectFactory(SEASON),
      [THEME]: this.createSelectFactory(THEME),
      [COLLECTION]: this.createSelectFactory(COLLECTION),
      [SIZE]: this.createSelectFactory(SIZE),
      [AVAILABILITY]: this.createSelectFactory(AVAILABILITY, this.createAvailabilityOptions()),
    };
  }

  // _setDefaultAvailability() {
  //   const {BOUGHT_BY_MARKET, IN_MARKET} = this.PRODUCT_CONSTANT.FILTER;
  //   return this.authService.isPersonalShopper()
  //     ? new this.ProductFilterOptionModel(IN_MARKET, 'In stock in market')
  //     : new this.ProductFilterOptionModel(BOUGHT_BY_MARKET, 'Bought by Market');
  // }

  getBaseFilters() {
    if (this.store.baseFilters) {
      return this.httpService.resolve(this.store.baseFilters);
    }

    return this.getProductFiltersConfig()
      .then(() => {
        const storeId = this.authService.currentStoreId();
        return this.geographyService.storeDetail(storeId);
      }).then((storeData) => {
        this.marketId = storeData.market.id;
        this.regionId = storeData.region.id;
        this.setMarketRegionInQueryStringIfEmpty();
        return this.httpService.all([
          this.httpService.get(this.createBaseFilterPathForGender('W', storeData.id, this.marketId)),
          this.httpService.get(this.createBaseFilterPathForGender('M', storeData.id, this.marketId)),
          this.httpService.get(this.createBaseFilterPathForGender('B', storeData.id, this.marketId)),
          this.httpService.get(this.createBaseFilterPathForGender('X', storeData.id, this.marketId)),
        ]);
      })
      .then((responses) => {
        const {GENDER} = this.PRODUCT_CONSTANT.FILTER;
        const sections = responses.map(res => this.applyModelToOptions(res.data.data));
        this.store.baseFilters = {
          SELECT_GENDER: this.SELECT[GENDER](sections.reduce((arr, section) => [...arr, ...section.gender], [])),
          sections,
        };
        return this.store.baseFilters;
      });
  }

  setMarketRegionInQueryStringIfEmpty() {
    const params = this.routerService.location.search();
    if (params.marketId || params.regionId) {
      return;
    }
    this.routerService.location.search({
      ...params,
      marketId: this.marketId,
      regionId: this.regionId,
    }).replace();
  }

  createBaseFilterPathForGender(genderId, storeId, marketId) {
    const {AVAILABILITY, ALL_AVAILABILITIES} = this.PRODUCT_CONSTANT.FILTER;
    return `${this.SERVICE}/category,gender?genderId=${genderId}&${AVAILABILITY}=${ALL_AVAILABILITIES}&marketId=${marketId}&storeId=${storeId}`;
  }

  query(params, {cacheable} = {}) {
    return this.httpService.all([
      this.fetchFilters(params, {cacheable}),
      this.geographyService.getRegions(),
      this.geographyService.getMarkets({params: {'filter[regionIds]': [params.regionId]}}),
      this.geographyService.getStores({params: {'filter[marketIds]': [params.marketId]}}),
    ])
      .then(([response, regionResponse, marketResponse, storeResponse]) => {
        const data = response.data.data;
        const geoData = this.formatOptionsForGeography([regionResponse, marketResponse, storeResponse]);
        const {TYPE, PRODUCTLINE, SEASON, THEME, AVAILABILITY, REGION, MARKET, STORE, SIZE, COLLECTION} = this.PRODUCT_CONSTANT.FILTER;
        const formattedOptions = this.applyModelToOptions(data);
        return [
          this.SELECT[TYPE](this.sortByName(formattedOptions.type)),
          this.SELECT[PRODUCTLINE](this.sortByName(formattedOptions.productline)),
          this.SELECT[SEASON](formattedOptions.season && formattedOptions.season.reverse()),
          this.SELECT[THEME](this.sortByName(formattedOptions.theme)),
          this.SELECT[COLLECTION](this.sortByName(formattedOptions.collection)),
          this.SELECT[SIZE](formattedOptions.size),
          this.SELECT[REGION](geoData.region, false),
          this.SELECT[MARKET](geoData.market),
          this.SELECT[STORE](geoData.store),
          this.SELECT[AVAILABILITY](),
        ];

        // return this.authService.isPersonalShopper()
        //   ? this.removeFiltersForPersonalShopper(filters)
        //   : filters;
      });
  }

  fetchFilters(params, {cacheable} = {}) {
    const paramsWithoutQ = {...params, q: undefined};
    const paramsEnrichedWithAvailability = this.enrichParamsWithAvailability(paramsWithoutQ);
    return this.httpService({
      method: 'GET',
      url: this.SERVICE,
      params: paramsEnrichedWithAvailability,
      cacheable,
    });
  }

  // removeFiltersForPersonalShopper(newFilters) {
  //   const {GENDER, CATEGORY, PRODUCTLINE, AVAILABILITY} = this.PRODUCT_CONSTANT.FILTER;
  //   const availableFilters = [GENDER, CATEGORY, PRODUCTLINE, AVAILABILITY];
  //   if (Array.isArray(newFilters)) {
  //     return newFilters.filter(filter => availableFilters.includes(filter.name));
  //   }
  //   return Object.keys(newFilters)
  //     .reduce((acc, filterName) => {
  //       if (!availableFilters.includes(filterName)) {
  //         delete acc[filterName];
  //       }
  //       return acc;
  //     }, newFilters);
  // }

  sortByName(array = []) {
    return array.sort((a = {}, b = {}) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
  }

  applyModelToOptions(data) {
    const {FILTER} = this.PRODUCT_CONSTANT;
    return Object.keys(data)
      .reduce((obj, section) => {
        const options = Object.keys(data[section])
          .map((k) => {
            const value = section === FILTER.SEASON ? this.ProductFilterOptionModel.formatSeasonLabel(k) : data[section][k];
            return new this.ProductFilterOptionModel(k, value);
          });
        obj[section] = options;
        return obj;
      }, {});
  }

  formatOptionsForGeography(geographyResponses) {
    const geographyKeys = [this.PRODUCT_CONSTANT.FILTER.REGION, this.PRODUCT_CONSTANT.FILTER.MARKET, this.PRODUCT_CONSTANT.FILTER.STORE];
    return geographyKeys.reduce((acc, key, index) => {
      return {
        ...acc,
        [key]: geographyResponses[index].map(area => new this.ProductFilterOptionModel(area.id, area.name)),
      };
    }, {});
  }

  createSelectFactory(filterName, baseOptions = []) {
    return (newOptions = [], hasDefault = true) => {
      const options = hasDefault
        ? [this.DEFAULT_OPTIONS[filterName], ...baseOptions, ...newOptions]
        : [...baseOptions, ...newOptions];

      return new this.ProductFilterSelectModel(filterName, options);
    };
  }

  createAvailabilityOptions() {
    const {ALL_AVAILABILITIES} = this.PRODUCT_CONSTANT.FILTER;
    return [
      new this.ProductFilterOptionModel(ALL_AVAILABILITIES, 'All products'),
    ];

    // if (this.authService.isOffice()) {
    //   return [
    //     ...baseOptions,
    //     new this.ProductFilterOptionModel(IN_MARKET, 'In stock in market'),
    //   ];
    // } else if (this.authService.isStore()) {
    //   return [
    //     ...baseOptions,
    //     new this.ProductFilterOptionModel(IN_MARKET, 'In stock in market'),
    //     new this.ProductFilterOptionModel(IN_STORE, 'In stock in store'),
    //   ];
    // } else if (this.authService.isPersonalShopper()) {
    //   return [
    //     new this.ProductFilterOptionModel(COMING_SOON, 'Coming soon'),
    //     new this.ProductFilterOptionModel(NEW, 'New'),
    //   ];
    // }
  }

  defaultParams(params) {
    // const {BOUGHT_BY_MARKET, AVAILABILITY} = this.PRODUCT_CONSTANT.FILTER;
    return {
      regionId: this.regionId,
      marketId: this.marketId,
      ...params,
    };
    // return this._setParamsForAvailabilityNew(newParams);
  }

  enrichParamsWithAvailability(params) {
    const {ALL_AVAILABILITIES, IN_STORE, IN_MARKET, IN_REGION} = this.PRODUCT_CONSTANT.FILTER;
    if (params.availability === ALL_AVAILABILITIES) {
      return params;
    }

    if (params.storeId) {
      return {...params, availability: IN_STORE };
    }
    if (params.marketId) {
      return {...params, availability: IN_MARKET };
    }
    if (params.regionId) {
      return {...params, availability: IN_REGION };
    }
  }

  // _setParamsForAvailabilityNew(params) {
  //   const {IN_MARKET, AVAILABILITY, NEW, COMING_SOON} = this.PRODUCT_CONSTANT.FILTER;
  //   const isNewAvailability = params.availability === NEW;
  //   const isComingSoonAvailability = params.availability === COMING_SOON;
  //   if (!isNewAvailability && !isComingSoonAvailability) {
  //     return {...params, launchDate: null};
  //   }
  //   return {
  //     ...params,
  //     [AVAILABILITY]: IN_MARKET,
  //     launchDate: isNewAvailability ? this.getLaunchDatesFilters('new') : this.getLaunchDatesFilters('comingSoon'),
  //   };
  // }

  // /**
  //  * @param {'new' | 'comingSoon'} value;
  //  * @returns {boolean}
  //  */
  // getLaunchDatesFilters(value) {
  //   if (value) {
  //     if (!this.store.launchDatesFilters[value]) {
  //       console.error(`${value} is not available in launchDatesFilters`);
  //     }
  //     return this.store.launchDatesFilters[value];
  //   }
  //   return this.store.launchDatesFilters;
  // }

  // _createLaunchDateFilter() {
  //   const now = new Date();
  //   const tomorrowDate = this.qwDateService.addDaysToDate(1, now);
  //   const newDate = this.qwDateService.addDaysToDate(-15, now);
  //   const comingSoonDate = this.qwDateService.addDaysToDate(30, now);
  //   const nowISODate = this.qwDateService.toISODate(now);
  //   const tomorrowISODate = this.qwDateService.toISODate(tomorrowDate);
  //   const newISODate = this.qwDateService.toISODate(newDate);
  //   const comingSoonISODate = this.qwDateService.toISODate(comingSoonDate);
  //   return {new: `${newISODate}|${nowISODate}`, comingSoon: `${tomorrowISODate}|${comingSoonISODate}`};
  // }

  getProductFiltersConfig() {
    return this.httpService({
      method: 'GET',
      url: `${this.httpService.BASE_PATH}/pim/filters_config/heaven`,
    }).then(({data}) => {
      this.store.filterConfig = _get(data, 'data[0].content', {});
      return this.store.filterConfig;
    });
  }

  getFilterConfig() {
    return this.store.filterConfig;
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product-filter/product-filter.service.js